import { getSkillsForAgent } from '../data/agentSkillsMap';

import { useTranslation } from 'react-i18next';
export default function AgentSkillsSection({ agentSlug, agentName }) {
  const { t } = useTranslation();
  const skills = getSkillsForAgent(agentSlug);

  if (!skills || skills.length === 0) return null;

  return (
    <section className="py-16 bg-slate-800">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-white mb-4">
          Included Skills — {agentName}
        </h2>
        <p className="text-zinc-400 mb-8">{t('agent_skills_section.each_agent_comes_with_pre_configured_skills_for')}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {skills.map(skill => (
            <div key={skill.id} className="bg-slate-900 border border-zinc-700 rounded-lg p-6 hover:border-amber-500 transition-colors">
              <div className="flex items-start gap-4">
                <span className="text-3xl">{skill.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-white">{skill.name}</h3>
                  <span className="text-xs text-amber-500 font-medium">{skill.category}</span>
                  <p className="text-zinc-400 text-sm mt-2">{skill.description}</p>
                  <span className="text-amber-500 font-bold text-sm mt-3 block">{skill.price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
